module.exports = __webpack_public_path__ + "20.9912ef82.png";